export default __webpack_public_path__ + "static/media/anssidLogo.9cccb8d2.svg";